import React, { lazy } from 'react';
export function BonusSection() {
  const allBonuses = [{
    title: 'Comunicación Eficaz en el Púlpito',
    description: 'Aprenderás las técnicas que los predicadores más impactantes usan para cautivar a su audiencia y transmitir el mensaje de Dios con poder y claridad.',
    value: '14.00',
    image: 'https://cdn.magicpatterns.com/uploads/nvSqKwsXoKp3tXqPDGngTd/Bono_1.png'
  }, {
    title: 'Desarrollo Espiritual del Predicador',
    description: 'Una guía profunda sobre cómo cultivar tu vida espiritual personal antes de subir al púlpito. Porque no puedes dar lo que no tienes.',
    value: '14.00',
    image: 'https://cdn.magicpatterns.com/uploads/eFXYWsZ4xFxnwzcAtrf2YW/Bono_2.png'
  }, {
    title: 'Exégesis y Hermenéutica Bíblica',
    description: 'Aprende los principios correctos para interpretar la Biblia por ti mismo. Nunca más dependerás de la opinión de otros para entender un pasaje.',
    value: '14.00',
    image: 'https://cdn.magicpatterns.com/uploads/fketHLxzvobMi4hcLM6C9U/Bono_3.png'
  }, {
    title: 'Historia de la Predicación Cristiana',
    description: 'Desde los primeros padres de la iglesia hasta los grandes avivamientos, entenderás cómo la predicación ha transformado al mundo durante 2,000 años.',
    value: '14.00',
    image: 'https://cdn.magicpatterns.com/uploads/2x8kKJqsX5DFTPNdSYxAuz/Bono_4.png'
  }, {
    title: 'Predicación Expositiva',
    description: 'Domina el arte de la Predicación Expositiva — el método que los predicadores más respetados del mundo usan para abrir la Palabra de Dios libro por libro.',
    value: '14.00',
    image: 'https://cdn.magicpatterns.com/uploads/mzbggqdk6hJsnEWDJNr8rb/Bono_5.png'
  }, {
    title: 'Predicación Temática',
    description: 'Aprende a construir sermones poderosos organizados por temas — fe, esperanza, perdón, familia — conectando versículos de toda la Biblia en un mensaje coherente.',
    value: '14.00',
    image: 'https://cdn.magicpatterns.com/uploads/onqGh1jgwzRCpRDTSnXJtG/Bono_6.png'
  }, {
    title: 'Preparación de Sermones — Guía Completa',
    description: 'Un paso a paso detallado que te lleva desde la selección del texto hasta la entrega final del mensaje. Tu mapa completo para transformar conocimiento en predicación.',
    value: '15.00',
    image: 'https://cdn.magicpatterns.com/uploads/ihzTH7oxXGD5AvTLBeeGAk/Bono_7.png'
  }];
  return <section className="py-12 md:py-16 relative" style={{
    background: '#EFE7D8'
  }} data-id="element-1">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-2">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-3">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold tracking-widest uppercase mb-3" style={{
          background: 'rgba(200,169,106,0.15)',
          border: '1px solid rgba(200,169,106,0.4)',
          color: '#B89555'
        }} data-id="element-4">
            Oferta Especial
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-2" style={{
          color: '#1C1C1C'
        }} data-id="element-5">
            7 Bonos GRATIS Si Ordenas Hoy
          </h2>
          <p className="text-base" style={{
          color: '#B89555'
        }} data-id="element-6">
            Valorados en $99.00 — Tuyos sin costo adicional
          </p>
          <div className="mt-3 mx-auto w-20 gold-divider" data-id="element-7" />
        </div>

        {/* 2-column grid — all 7 bonuses with images */}
        <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-8">
          {allBonuses.map((bonus, index) => <div key={index} className={`rounded-xl overflow-hidden flex flex-col${index === 6 ? ' col-start-1 col-end-2 mx-auto w-full' : ''}`} style={{
          background: '#F6F1E7',
          border: '1px solid rgba(200,169,106,0.35)',
          boxShadow: '0 3px 14px rgba(60,40,10,0.07)'
        }} data-id="element-9">
              {/* Image */}
              <div className="w-full overflow-hidden" style={{
            borderBottom: '1px solid rgba(200,169,106,0.2)',
            aspectRatio: '3/4'
          }} data-id="element-10">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover block" width={400} height={533} loading="lazy" decoding="async" data-id="element-11" />
              </div>

              {/* Content */}
              <div className="p-3 flex flex-col flex-1" data-id="element-12">
                <h3 className="text-xs font-bold mb-1.5 leading-snug" style={{
              color: '#161616'
            }} data-id="element-13">
                  <span style={{
                color: '#B89555'
              }} data-id="element-14">
                    BONO #{index + 1}:
                  </span>{' '}
                  {bonus.title.toUpperCase()}
                </h3>
                <p className="text-xs leading-relaxed mb-2 flex-1" style={{
              color: '#505050'
            }} data-id="element-15">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-1.5 mt-auto flex-wrap" data-id="element-16">
                  <span className="text-xs font-bold" style={{
                color: '#8A8A8A',
                textDecoration: 'line-through'
              }} data-id="element-17">
                    ${bonus.value}
                  </span>
                  <span className="text-xs" style={{
                color: '#8A8A8A'
              }} data-id="element-18">
                    —
                  </span>
                  <span className="text-xs font-black uppercase tracking-wide" style={{
                color: '#1A6B3A'
              }} data-id="element-19">
                    ¡GRATIS!
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Total Value Box */}
        <div className="p-6 rounded-2xl text-center" style={{
        background: '#FBF8F2',
        border: '2px solid rgba(200,169,106,0.4)',
        boxShadow: '0 4px 20px rgba(60,40,10,0.08)'
      }} data-id="element-20">
          <p className="text-xs uppercase tracking-widest font-bold mb-2" style={{
          color: '#B89555'
        }} data-id="element-21">
            Valor Total Real
          </p>
          <p className="text-3xl font-bold mb-1" style={{
          color: '#8A8A8A',
          textDecoration: 'line-through'
        }} data-id="element-22">
            $132.00
          </p>
          <p className="text-base font-bold" style={{
          color: '#1A6B3A'
        }} data-id="element-23">
            ¡Hoy te llevas todo GRATIS con tu compra!
          </p>
        </div>
      </div>
    </section>;
}